import { render, staticRenderFns } from "./UserTransactionRecordsList.vue?vue&type=template&id=1268e4a4"
import script from "./UserTransactionRecordsList.vue?vue&type=script&lang=js"
export * from "./UserTransactionRecordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports